import { loader } from 'graphql.macro'

export default async function confirmServiceRequest ({ dataLoaders, variables }) {
  const schema = loader('./confirmServiceRequest.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      orderId: variables.orderId,
      jobId: variables.jobId
    }
  })

  return response.confirmServiceRequest
}
